import React, { useState } from 'react';

export const StorageContext = React.createContext([]);
export const ApplicationContext = React.createContext([]);
export const HomeContext = React.createContext([]);
export const MenuContext = React.createContext([]);
export const SerenelyContext = React.createContext([]);
export const EffortlesslyContext = React.createContext([]);
export const PowerfullyContext = React.createContext([]);
export const SmartlyContext = React.createContext([]);

export const StorageProvider = ({ children }) => {
    const [data, setter] = useState([]);
    return <StorageContext.Provider value={[data, setter]}>{children}</StorageContext.Provider>;
};

export const ApplicationProvider = ({ children }) => {
    const [data, setter] = useState({});
    return <ApplicationContext.Provider value={[data, setter]}>{children}</ApplicationContext.Provider>;
};

export const HomeProvider = ({ children }) => {
    const [data, setter] = useState({});
    return <HomeContext.Provider value={[data, setter]}>{children}</HomeContext.Provider>;
};

export const MenuProvider = ({ children }) => {
    const [data, setter] = useState([]);
    return <MenuContext.Provider value={[data, setter]}>{children}</MenuContext.Provider>;
};

export const SerenelyProvider = ({ children }) => {
    const [data, setter] = useState([]);
    return <SerenelyContext.Provider value={[data, setter]}>{children}</SerenelyContext.Provider>;
};
export const EffortlesslyProvider = ({ children }) => {
    const [data, setter] = useState([]);
    return <EffortlesslyContext.Provider value={[data, setter]}>{children}</EffortlesslyContext.Provider>;
};

export const PowerfullyProvider = ({ children }) => {
    const [data, setter] = useState([]);
    return <PowerfullyContext.Provider value={[data, setter]}>{children}</PowerfullyContext.Provider>;
};

export const SmartlyProvider = ({ children }) => {
    const [data, setter] = useState([]);
    return <SmartlyContext.Provider value={[data, setter]}>{children}</SmartlyContext.Provider>;
};
